module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../hyperdb-utils/~/babel-runtime/core-js/object/create.js
// module id = 752
// module chunks = 0